export const getQzConnected = state => {
  return state.printer.qzConnected
}

export const totalDeliverymenOnline = state => {
  return state.deliverymenOnline
}
